import { render, staticRenderFns } from "./HealHarm.vue?vue&type=template&id=94c79000"
import script from "./HealHarm.vue?vue&type=script&lang=js"
export * from "./HealHarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports